import React, { useEffect, useRef} from "react";
import { useLocation } from "react-router-dom";

const HEADER_HEIGHT = 64; // 4rem (nav height)
const SCROLL_OFFSET = HEADER_HEIGHT + 32; // extra padding for visual spacing

//Component to scroll to a specific part of the page when an element is clicked
const ScrollToAnchor = () => {
    const location = useLocation();
    const lastHash = useRef('');

    useEffect(()=>{
        if(location.hash){
            lastHash.current = location.hash.slice(1);
        };

        const id = lastHash.current;
        const el = id ? document.getElementById(id) : null;

        if(el){
            setTimeout(()=>{
                const elementPosition = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
                const offsetPosition = elementPosition - SCROLL_OFFSET;

                window.scrollTo({
                     top: offsetPosition,
                     behavior: "smooth",
                });
                lastHash.current = '';
            }, 100);
        }

    }, [location]);

    return null;
};

export default ScrollToAnchor;